<template>
  <div class="containerTable">
    <vxe-toolbar id="toolbarId_ca41" :custom="{ storage: true }" export :refresh="{ query: RefreshList }">
      <template v-slot:buttons>
        <el-button v-if="getLimit('WithdrawalsRecord_search_button')" @click="funcFilter">
          查询
        </el-button>
        <el-button v-if="getLimit('WithdrawalsRecord_statusQuery_button')" @click="statusQuery">
          更新提现结果
        </el-button>
        <el-button v-if="getLimit('WithdrawalsRecord_export_button')" @click="funcExport()">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="outTradeNo" title="交易流水号" min-width="250" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.outTradeNo" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="orderNo" title="网商提现订单号" min-width="250" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.orderNo" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="totalAmount" title="金额(元)" min-width="200" sortable />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input v-model="listQuery.totalAmountStart" type="number" placeholder="下限" clearable />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalAmountEnd"
                type="number"
                placeholder="上限"
                clearable
                @input="(value) => listQuery.totalAmountEnd = value < listQuery.totalAmountStart ? listQuery.totalAmountStart : value"
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="partyName" title="提现人姓名" min-width="130" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.partyName" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="partyPhone" title="提现人手机号" min-width="130" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.partyPhone" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="status" title="状态" :formatter="formatterStatus" min-width="130" sortable />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="withdrawApplyDate" title="提现时间" min-width="420" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.withdrawApplyDateRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'withdrawApplyDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="withdrawFinishDate" title="提现完成时间" min-width="420" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.withdrawFinishDateRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'withdrawFinishDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="withdrawType" title="提现类型" :formatter="formatterType" min-width="130" sortable />
        <template v-slot:header>
          <el-select v-model="listQuery.withdrawType" clearable placeholder="请选择">
            <el-option v-for="item in drawOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="errorDesc" title="审核备注" min-width="250" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.errorDesc" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="memo" title="提现备注 " min-width="250" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.memo" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="50" fixed="right">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.status == 'WAIT_AUDIT'" class="item" effect="dark" content="审核" placement="top" width="50">
            <vxe-button type="text" @click="WithdrawalClick(scope.row.code)">
              <i class="el-icon-check" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.status == 'CONVERSION' || scope.row.status == 'AUDITED'"
            class="item"
            effect="dark"
            content="尝试提现"
            placement="top"
            width="50"
          >
            <vxe-button type="text" @click="tryRealizeClick(scope.row.code)">
              <i class="el-icon-wallet" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal v-model="WithdrawalFlag" width="500" height="200" title="审核" resize>
      <compDetail ref="withdrawaRef" @event2="toshengs" />
    </vxe-modal>
    <el-dialog title="失败信息" :visible.sync="dialogTableVisible" class="abow_dialog">
      <el-table :data="errorData" height="100%" border>
        <el-table-column property="code" label="订单号" width="290" />
        <el-table-column property="msg" label="错误描述" width="300" />
      </el-table>
    </el-dialog>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compDetail from './components/Variationdetails.vue'
import { getBankWithdraw, obtainWithdrawQuery } from '@/api/InternetBanking'
import request from '@/utils/request'
export default {
  components: {
    compDetail
  },
  data() {
    return {
      loading: false,
      WithdrawalFlag: false,
      tableData: [],
      errorData: [],
      exportObj: {
        exportUrl: '/ntocc-tms-api/mybankWithdraw/exportMybankWithdrawList', //导出接口
        name: '提现记录'
      },
      listQuery: {
        withdrawApplyDateRange: '',
        withdrawFinishDateRange: '',
        status,
        pageNum: 1,
        pageSize: 20,
        sortField: '',
        sortType: '',
        total: 0
      },
      // Pagingconf: [],
      statusOptions: [
        { value: 'SUCCESS', label: '成功' },
        { value: 'FAIL', label: '失败' },
        { value: 'DEALING', label: '处理中' },
        { value: 'WAIT_AUDIT', label: '待审核' },
        { value: 'AUDITED', label: '审核通过' },
        { value: 'CONVERSION', label: '余额转换中' },
        { value: 'REJECT', label: '驳回' }
      ],
      proofStatusOptions: [
        { value: 0, label: '待审核' },
        { value: 1, label: '处理中' },
        { value: 2, label: '成功' },
        { value: 3, label: '失败' },
        { value: 4, label: '部分失败' }
      ],
      drawOptions: [
        { value: 0, label: '可用余额' },
        { value: 1, label: '保证金' }
      ],
      dialogTableVisible: false
    }
  },
  watch: {
    $route(to, from) {
      const v = to.query.todo
      if (v) {
        this.listQuery.status = 'WAIT_AUDIT'
      } else {
        this.listQuery.status = ''
      }
      this.findList()
    }
  },
  created() {
    const v = this.$route.query.todo
    if (v) {
      this.listQuery.status = 'WAIT_AUDIT'
    }
    this.findList()
  },
  methods: {
    findList() {
      this.loading = true
      return new Promise((resolve) => {
        getBankWithdraw(this.listQuery).then((response) => {
          this.tableData = response.data.records
          // response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
          this.listQuery.total = response.data.total
          this.sumObject = response.data.sumObject
          this.loading = false
          resolve()
        })
      })
    },
    //支付状态查询
    statusQuery() {
      obtainWithdrawQuery().then((response) => {
        if (response.status === 500) {
          this.dialogTableVisible = true
          this.errorData = response.data
        } else {
          let type = response.status === 0 ? 'success' : 'error'
          this.findList()
          this.$message({
            message: response.msg,
            type: type
          })
        }
      })
    },
    //审核
    WithdrawalClick(c) {
      this.$refs.withdrawaRef.findCode(c)
      this.WithdrawalFlag = true
    },
    //尝试提现
    tryRealizeClick(code) {
      request({
        url: `/ntocc-tms-api/mybankWithdraw/tryRealize`,
        method: 'put',
        params: { code: code }
      }).then((response) => {
        if (response.status == 0) {
          this.findList()
        }
      })
    },
    toshengs() {
      this.WithdrawalFlag = false
      this.findList()
    },
    // 翻译状态
    formatterStatus({ cellValue }) {
      const item = this.statusOptions.find((item) => item.value === cellValue)
      return item ? item.label : ''
    },
    // 翻译凭证状态
    formatterProofStatus({ cellValue }) {
      const item = this.proofStatusOptions.find(
        (item) => item.value === cellValue
      )
      return item ? item.label : ''
    },
    formatterType({ cellValue }) {
      const item = this.drawOptions.find((item) => item.value === cellValue)
      return item ? item.label : ''
    }
  }
}
</script>
<style scoped>
.abow_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}
::v-deep.el-dialog {
  margin: 0 auto !important;
  height: 60%;
  width: 32%;
  overflow: hidden;
}
::v-deep .el-dialog .el-dialog__body {
  position: absolute;
  left: 10px;
  top: 58px;
  bottom: 0;
  right: 0;
  padding: 0;
  z-index: 1;
  overflow: hidden;
  overflow-y: auto;
}
</style>
